import {styled} from "@mui/system";
import {ReactComponent as LionIconSvg} from './lion.svg';

const MainMenuLionIcon = styled(LionIconSvg)({
    width: '52px',
    height: 'auto',
    flexShrink: 0, // Prevent shrinking
});

export default MainMenuLionIcon;